<template lang="pug">
vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="addSelected" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="selected.length >= 1" :vm-active="isOrdersModalVisible" :vm-title="$t('strings.select_orders')")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-table(multiple v-model="selected" max-height="350px" :data="shipments")
        template(slot="thead")
          vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('shipments.' + column) }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
              slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
              slot(v-if="column == 'created_at' || column == 'shipment_date' || column == 'arrival_date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
              slot(v-if="column != 'status_id' && column != 'created_at' && column != 'shipment_date' && column != 'arrival_date' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
              vm-status-indicator(v-if="column == 'status_id'" :pulse="data[indextr]['status_id']" :color="colorStatus(data[indextr]['status_id'])") {{ $t('shipments.'+ data[indextr]['status_id']) }}
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('LabelGroups')

export default {
  name: 'ModalLabelOrders',
  mixins: [ModalMixin1],
  data: () => ({
    selected: [],
    columns: [
      'folio',
      'supplier_display',
      'shipment_date',
      'lead_time',
      'arrival_date',
      'notes',
      'status_id',
      'created_at'
    ],
    status: [
      {
        value: 1,
        color: 'warning'
      },
      {
        value: 2,
        color: 'success'
      },
      {
        value: 3,
        color: 'warning'
      },
      {
        value: 4,
        color: 'success'
      },
      {
        value: 5,
        color: 'success'
      }
    ]
  }),
  computed: {
    ...mapGetters(['isOrdersModalVisible', 'shipments'])
  },
  methods: {
    ...mapActions([
      'addLabelsFromShipments',
      'setProductsByShipmentModalVisible',
      'setLoader'
    ]),
    async addSelected () {
      const ids = this.selected.map(element => element.id)
      await this.addLabelsFromShipments(ids)
      this.setLoader(false)
      this.setProductsByShipmentModalVisible(false)
      this.selected = []
    },
    close () {
      this.setProductsByShipmentModalVisible(false)
    },
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    nameStatus (code) {
      return this.status.find(e => e.value === code)['text']
    }
  }
}
</script>
